import { Issuer } from "api/generated/cms";
import { parseCmsId } from "./parseCmsId";
import { useGetCmsIssuers } from "./useGetCmsIssuers";

interface UseGetIssuerCmsResult {
  loading: boolean;
  error: Error | null;
  data: Issuer | null | undefined;
}

export const useGetIssuerCms = (
  cmsId: number | undefined
): UseGetIssuerCmsResult => {
  const { loading, error, data: issuers } = useGetCmsIssuers();

  if (cmsId === undefined || !Number.isFinite(cmsId)) {
    return { loading: false, error: null, data: null };
  }

  if (loading || !issuers) {
    return { loading, error: error ?? null, data: undefined };
  }

  const issuer = issuers.find((i) => parseCmsId(i.id) === cmsId) ?? null;
  return { loading: false, error: error ?? null, data: issuer };
};
